<template>
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && members.length == 0">
            No members can be found
        </div>

        <div class="is-pulled-right" v-if="loading == false" style="display:none">
            <input type="text" class="input" v-model="search" placeholder="Search ..."/>
        </div>

        <h4 class="title">Year 2025/2026</h4>

        <table class="table is-fullwidth is-striped is-hoverable" v-if="loading == false && members.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Qualifying Weeks</th>
                    
                    <th>Total Pay<br /> (past 12 weeks)</th>
                    <th>Total Hours<br /> (past 12 weeks)</th>
                    <th>Weekly Average Hours<br /> (past 12 weeks)</th>
                    <th>Averge Pay<br /> (past 12 weeks)</th>
                    
                    <th>Current Allowance</th>
                    <th>Holiday Taken So Far</th>
                    <th>Can Take</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in members" :key="row.id">
                    <td><router-link :to="'/members/' + row.id" target="_blank">{{row.forename}} {{ row.surname }}</router-link></td>
                    <td>{{ row.holiday_pay.qualifying_weeks}} weeks</td>
                    <td>£{{ row.holiday_pay.total_pay  }}</td>
                    <td>{{ row.holiday_pay.total_hours }} hours</td>
                    <td>{{ row.holiday_pay.average_hours }} hours</td>
                    <td>£{{ row.holiday_pay.average_pay }} p/h</td>
                    
                    <td>{{ row.holiday_pay.holiday_allowance }}</td>
                    <td>{{ row.holiday_pay.holiday_taken_requested }} hours</td>
                    <td><strong>{{ row.holiday_pay.holiday_allowance_oustanding }} hours</strong></td>
                    
                </tr>
                
               
            </tbody>

        </table>

        <strong>Allowance is calculated by taking the average hours per week (over past 12 weeks), multiplying by 5.6, then dividing by 52 to get the weekly average.<br />
        Then divide the total pay in last 12 weeks by total hours in last 12 weeks to get the average pay.</strong>
            <p>&nbsp;</p>
        <p>This gives us a total holiday pay liability of £{{  totalHolidayPay }} in this tax year. But I can't calculate total pay for the year on this page. This value will also change every time a timesheet is processed.</p>
        
    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

export default {
    
      name: 'ClientGroups',
        mixins: [MemberMixin],
        data: function () {
            return {
                   search: '',
                   members: [],
                   loading: false,
                   accessToken: ''
                  
            }
        },
        methods: {
            async getMembersWithHolidayPay() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "members?include_holiday_pay=1")
                .then(
                    (members => {
                        this.$set(this, "members", members);
                        this.loading=false
                    }).bind(this)
                );
            },
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getMembersWithHolidayPay();
                
            });
        
        },
        computed : {
            totalHolidayPay() {
            if (!this.members) return 0;

            const total = Object.values(this.members).reduce((sum, member) => {
                const avg = Number(member.holiday_pay?.average_pay ?? 0);
                const allowance = Number(member.holiday_pay?.holiday_allowance ?? 0);
                return sum + avg * allowance;
                }, 0);

                return Number(total.toFixed(2)); // rounded to 2 decimals
        }
        }
    }
</script>